import * as Sentry from '@sentry/vue'
import type { FetchResponse } from 'ofetch'

interface PossiblyHttpError {
  status?: number
  statusCode?: number
  response?: FetchResponse<unknown>
}

const extractStatus = (ex: unknown): number | undefined => {
  if (!ex || typeof ex !== 'object') {
    return undefined
  }

  const candidate = ex as PossiblyHttpError

  return candidate.response?.status ?? candidate.status ?? candidate.statusCode
}

export const useHandleException = (ex: unknown) => {
  const { error } = console
  const status = extractStatus(ex)

  if (status !== undefined && status >= 400 && status < 600) {
    return
  }

  try {
    Sentry.captureException(ex)
  }
  catch (sentryError: unknown) {
    error(sentryError)
  }
}
